// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// date-fns
import startOfTomorrow from 'date-fns/startOfTomorrow';

// ----------------------------------------------------------------------

interface IProps {
  name: string;
  isFutureOnly?: boolean;
}

export default function RHFDatePicker({ name, isFutureOnly, ...other }: IProps & TextFieldProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            {...field}
            disabled={other.disabled}
            minDate={isFutureOnly ? startOfTomorrow() : undefined}
            renderInput={(params) => (
              <TextField {...params} fullWidth error={!!error} helperText={error?.message} {...other} />
            )}
            showDaysOutsideCurrentMonth
            views={['year', 'month', 'day']}
          />
        </LocalizationProvider>
      )}
    />
  );
}
